export enum ProviderStatus {
    Unknown = 0,
    None = 1,
    Ok = 2,
    NotConfigured = 3,
    Inactive = 4,
    Unavailable = 100,
}
